import HSDropdown from "preline/plugins/dropdown-non-auto";
import HSRemoveElement from "preline/plugins/remove-element-non-auto";
import HSSelect from "preline/plugins/select-non-auto";

const prelineComponents = [HSDropdown, HSRemoveElement, HSSelect];

const resetPrelineSelects = () => {
  // Turbo may cache Preline's generated wrapper; unwrap it so autoInit is idempotent.
  document
    .querySelectorAll(".preline-select > .hs-select")
    .forEach((wrapper) => {
      const select = wrapper.querySelector("[data-hs-select]");
      select ? wrapper.replaceWith(select) : wrapper.remove();
    });

  window.$hsSelectCollection = [];
};

const initPreline = () => {
  resetPrelineSelects();
  prelineComponents.forEach((component) => component.autoInit());
};

document.addEventListener("turbo:load", initPreline);
document.addEventListener("turbo:frame-load", initPreline);
document.addEventListener("turbo:render", initPreline);
document.addEventListener("turbo:before-cache", resetPrelineSelects);
document.addEventListener("turbo:before-stream-render", (event) => {
  const render = event.detail.render;

  event.detail.render = (streamElement) => {
    render(streamElement);
    queueMicrotask(initPreline);
  };
});
